import React from 'react'

import "./table.css"

const Table = (props) => <table className="styled-table" {...props} />
export default Table
